// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: zZpeb78hpgm25czKcWXUB
// Component: SbDBdaKpBdAf

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import { NavigationBar } from "@plasmicpkgs/plasmic-nav"; // plasmic-import: jGx9tiKJoex/codeComponent

import { useScreenVariants as useScreenVariantsgi6NsXdthHnSo } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: Gi6NSXdthHnSO/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_blank_project_mobile_first.module.css"; // plasmic-import: zZpeb78hpgm25czKcWXUB/projectcss
import sty from "./PlasmicHomepage.module.css"; // plasmic-import: SbDBdaKpBdAf/css

import CopyrightSvgrepoComsvgIcon from "./icons/PlasmicIcon__CopyrightSvgrepoComsvg"; // plasmic-import: CznUmyML8C/icon

export type PlasmicHomepage__VariantMembers = {};
export type PlasmicHomepage__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomepage__VariantsArgs;
export const PlasmicHomepage__VariantProps = new Array<VariantPropType>();

export type PlasmicHomepage__ArgsType = {};
type ArgPropType = keyof PlasmicHomepage__ArgsType;
export const PlasmicHomepage__ArgProps = new Array<ArgPropType>();

export type PlasmicHomepage__OverridesType = {
  home?: p.Flex<"div">;
  navigationBar?: p.Flex<typeof NavigationBar>;
  hero?: p.Flex<"div">;
  foreground2?: p.Flex<"div">;
  services?: p.Flex<"section">;
  aboutUs?: p.Flex<"section">;
  contactUs?: p.Flex<"section">;
  footer?: p.Flex<"section">;
  svg?: p.Flex<"svg">;
};

export interface DefaultHomepageProps {
  className?: string;
}

const __wrapUserFunction =
  globalThis.__PlasmicWrapUserFunction ?? ((loc, fn) => fn());
const __wrapUserPromise =
  globalThis.__PlasmicWrapUserPromise ??
  (async (loc, promise) => {
    return await promise;
  });

function PlasmicHomepage__RenderFunc(props: {
  variants: PlasmicHomepage__VariantsArgs;
  args: PlasmicHomepage__ArgsType;
  overrides: PlasmicHomepage__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const [$queries, setDollarQueries] = React.useState({});

  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsgi6NsXdthHnSo()
  });

  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"home"}
          data-plasmic-override={overrides.home}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.home
          )}
          id={"wrapper" as const}
        >
          <NavigationBar
            data-plasmic-name={"navigationBar"}
            data-plasmic-override={overrides.navigationBar}
            brand={
              <a
                className={classNames(
                  projectcss.all,
                  projectcss.a,
                  sty.link__amih1
                )}
                href={"#" as const}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__c8Dj
                  )}
                >
                  {"Pro Property Services"}
                </div>
              </a>
            }
            className={classNames("__wab_instance", sty.navigationBar)}
            closeButton={
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__x0Wxk)}
                displayHeight={"auto" as const}
                displayMaxHeight={"none" as const}
                displayMaxWidth={"none" as const}
                displayMinHeight={"0" as const}
                displayMinWidth={"0" as const}
                displayWidth={"auto" as const}
                src={"https://static1.plasmic.app/close.svg" as const}
              />
            }
            itemsGap={8 as const}
            menuItems={
              <React.Fragment>
                <a
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    projectcss.__wab_text,
                    sty.link__yteEq
                  )}
                  href={"#wrapper" as const}
                >
                  {"Home"}
                </a>
                <a
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    projectcss.__wab_text,
                    sty.link__sEvw2
                  )}
                  href={"#services" as const}
                >
                  {"Services"}
                </a>
                <a
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    projectcss.__wab_text,
                    sty.link__mVJcg
                  )}
                  href={"#about" as const}
                >
                  {"About Us"}
                </a>
                <a
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    projectcss.__wab_text,
                    sty.link__v5UNt
                  )}
                  href={"#contact" as const}
                >
                  {"Contact"}
                </a>
                <a
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    projectcss.__wab_text,
                    sty.link__iW1V
                  )}
                  href={"tel:18475614058" as const}
                >
                  {"(847) 561-4058"}
                </a>
              </React.Fragment>
            }
            openButton={
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__hXz1O)}
                displayHeight={"auto" as const}
                displayMaxHeight={"none" as const}
                displayMaxWidth={"none" as const}
                displayMinHeight={"0" as const}
                displayMinWidth={"0" as const}
                displayWidth={"auto" as const}
                src={"https://static1.plasmic.app/menu.svg" as const}
              />
            }
            responsiveBreakpoint={768 as const}
          />

          <div
            data-plasmic-name={"hero"}
            data-plasmic-override={overrides.hero}
            className={classNames(projectcss.all, sty.hero)}
          >
            <p.Stack
              as={"div"}
              data-plasmic-name={"foreground2"}
              data-plasmic-override={overrides.foreground2}
              hasGap={true}
              className={classNames(projectcss.all, sty.foreground2)}
            >
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__czMec)}
              >
                <h1
                  className={classNames(
                    projectcss.all,
                    projectcss.h1,
                    projectcss.__wab_text,
                    sty.h1__iYmXp
                  )}
                >
                  <React.Fragment>
                    <React.Fragment>{""}</React.Fragment>
                    {
                      <h1
                        className={classNames(
                          projectcss.all,
                          projectcss.h1,
                          projectcss.__wab_text,
                          sty.h1__kaZhj
                        )}
                      >
                        {"Pro Property Services"}
                      </h1>
                    }
                    <React.Fragment>{""}</React.Fragment>
                  </React.Fragment>
                </h1>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__lVlFb
                  )}
                >
                  {
                    " Your all-in-one solution for maintaining, enhancing, and safeguarding your residential or commercial property. "
                  }
                </div>
              </p.Stack>
            </p.Stack>
          </div>
          <section
            data-plasmic-name={"services"}
            data-plasmic-override={overrides.services}
            className={classNames(projectcss.all, sty.services)}
            id={"services" as const}
          >
            <h2
              className={classNames(
                projectcss.all,
                projectcss.h2,
                projectcss.__wab_text,
                sty.h2__tRtu4
              )}
              id={``}
            >
              {"Services"}
            </h2>
            <div className={classNames(projectcss.all, sty.columns__jl8Bc)}>
              <div className={classNames(projectcss.all, sty.column__d6T6J)}>
                <div
                  className={classNames(projectcss.all, sty.freeBox___7K1Q6)}
                >
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__uVkce)}
                  >
                    <h3
                      className={classNames(
                        projectcss.all,
                        projectcss.h3,
                        projectcss.__wab_text,
                        sty.h3__d6V7X
                      )}
                    >
                      {"Construction"}
                    </h3>
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___6Dz9
                      )}
                    >
                      {
                        "We are able to handle all your general contractor needs."
                      }
                    </div>
                  </p.Stack>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.column__heawe)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox___1Gj5)}
                >
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__huRhO)}
                  >
                    <h3
                      className={classNames(
                        projectcss.all,
                        projectcss.h3,
                        projectcss.__wab_text,
                        sty.h3__xdv3F
                      )}
                    >
                      {"Snow Removal"}
                    </h3>
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__c9Jb
                      )}
                    >
                      {
                        "Stay out of the cold and let us handle snow removal for your property."
                      }
                    </div>
                  </p.Stack>
                </p.Stack>
              </div>
              <div className={classNames(projectcss.all, sty.column__zebnw)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__bHei7)}
                >
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__xNm7P)}
                  >
                    <h3
                      className={classNames(
                        projectcss.all,
                        projectcss.h3,
                        projectcss.__wab_text,
                        sty.h3__zVj3
                      )}
                    >
                      {"Painting"}
                    </h3>
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__pOAab
                      )}
                    >
                      {hasVariant(globalVariants, "screen", "desktopOnly")
                        ? "Our expert painters will have your rooms looking fresh and new."
                        : "Our expert painters will have your rooms looking fresh and new in no time."}
                    </div>
                  </p.Stack>
                </p.Stack>
              </div>
              <div className={classNames(projectcss.all, sty.column__hqpuM)}>
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__swWw0)}
                >
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__yvTj9)}
                  >
                    <h3
                      className={classNames(
                        projectcss.all,
                        projectcss.h3,
                        projectcss.__wab_text,
                        sty.h3__nuTy
                      )}
                    >
                      {"General Repairs"}
                    </h3>
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__dtdJm
                      )}
                    >
                      {
                        "We are available for any repairs your property may require."
                      }
                    </div>
                  </p.Stack>
                </p.Stack>
              </div>
            </div>
          </section>
          <section
            data-plasmic-name={"aboutUs"}
            data-plasmic-override={overrides.aboutUs}
            className={classNames(projectcss.all, sty.aboutUs)}
            id={"about" as const}
          >
            <h2
              className={classNames(
                projectcss.all,
                projectcss.h2,
                projectcss.__wab_text,
                sty.h2__ojf6W
              )}
            >
              {"About Us"}
            </h2>
            <div className={classNames(projectcss.all, sty.columns___5PqdH)}>
              <div className={classNames(projectcss.all, sty.column__r8WXc)}>
                <div
                  className={classNames(projectcss.all, sty.freeBox__qYoXn)}
                />
              </div>
              <div className={classNames(projectcss.all, sty.column___7Vtuc)}>
                {(
                  hasVariant(globalVariants, "screen", "desktopOnly")
                    ? true
                    : true
                ) ? (
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__vEqGg
                    )}
                  >
                    {
                      " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer facilisis accumsan dolor. Donec pretium eros vitae neque viverra lacinia. Morbi sit amet aliquet nisl, vel interdum risus. Donec elit nisi, maximus sed libero eu, varius bibendum risus. Pellentesque convallis nunc vel aliquam iaculis. Nullam dapibus et nisi et efficitur. Aliquam vestibulum risus sit amet odio laoreet, eget fermentum erat pulvinar. Fusce nec purus nulla. Ut non risus at neque placerat vulputate. Nulla viverra tincidunt nunc, quis elementum ante convallis ut.\n\nVivamus posuere neque vitae risus posuere laoreet. Integer elementum pretium lectus, in ultricies mauris dignissim vitae. Ut finibus est velit, sagittis elementum nibh gravida nec. Pellentesque at libero sapien. Donec aliquam ipsum vel nisi dictum, ac feugiat felis sollicitudin. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
                    }
                  </div>
                ) : null}
              </div>
            </div>
          </section>
          <section
            data-plasmic-name={"contactUs"}
            data-plasmic-override={overrides.contactUs}
            className={classNames(projectcss.all, sty.contactUs)}
            id={"contact" as const}
          >
            <h2
              className={classNames(
                projectcss.all,
                projectcss.h2,
                projectcss.__wab_text,
                sty.h2___2RWje
              )}
            >
              {"Contact Us"}
            </h2>
            <div className={classNames(projectcss.all, sty.columns__mv6Dp)}>
              <div className={classNames(projectcss.all, sty.column__josqL)}>
                <div className={classNames(projectcss.all, sty.freeBox__ninho)}>
                  <h3
                    className={classNames(
                      projectcss.all,
                      projectcss.h3,
                      projectcss.__wab_text,
                      sty.h3__jArHl
                    )}
                  >
                    {"Call"}
                  </h3>
                  <a
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      sty.link__mh7Mg
                    )}
                    href={"tel:18475614058" as const}
                  >
                    {"(847) 561-4058"}
                  </a>
                </div>
              </div>
              {(
                hasVariant(globalVariants, "screen", "desktopOnly")
                  ? true
                  : true
              ) ? (
                <div className={classNames(projectcss.all, sty.column__sxk8L)}>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__z8He9)}
                  >
                    <h3
                      className={classNames(
                        projectcss.all,
                        projectcss.h3,
                        projectcss.__wab_text,
                        sty.h3__yKblf
                      )}
                    >
                      {"Email"}
                    </h3>
                    <a
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        sty.link__jW6AH
                      )}
                      href={"mailto:info@propropertyservices.net" as const}
                    >
                      {"info@propropertyservices.net"}
                    </a>
                  </div>
                </div>
              ) : null}
              <div className={classNames(projectcss.all, sty.column__a4Wz6)}>
                <div
                  className={classNames(projectcss.all, sty.freeBox___4HjCc)}
                />
              </div>
            </div>
          </section>
          <section
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames(projectcss.all, sty.footer)}
          >
            <div className={classNames(projectcss.all, sty.columns__rvonl)}>
              <div className={classNames(projectcss.all, sty.column__powA2)}>
                {(
                  hasVariant(globalVariants, "screen", "desktopOnly")
                    ? true
                    : true
                ) ? (
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__pwUtx
                    )}
                  >
                    {"820 Dundee Ave. Elgin, IL 60120"}
                  </div>
                ) : null}
                {true ? (
                  <div
                    className={classNames(projectcss.all, sty.freeBox__jhD6)}
                  >
                    <CopyrightSvgrepoComsvgIcon
                      data-plasmic-name={"svg"}
                      data-plasmic-override={overrides.svg}
                      className={classNames(projectcss.all, sty.svg)}
                      role={"img"}
                    />

                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__s1CyH
                      )}
                    >
                      {" 2023 Pro Property Services "}
                    </div>
                    {(
                      hasVariant(globalVariants, "screen", "desktopOnly")
                        ? true
                        : true
                    ) ? (
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__lrztr
                        )}
                      >
                        {"820 Dundee Ave. Elgin, IL 60120"}
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>
            </div>
          </section>
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  home: [
    "home",
    "navigationBar",
    "hero",
    "foreground2",
    "services",
    "aboutUs",
    "contactUs",
    "footer",
    "svg"
  ],
  navigationBar: ["navigationBar"],
  hero: ["hero", "foreground2"],
  foreground2: ["foreground2"],
  services: ["services"],
  aboutUs: ["aboutUs"],
  contactUs: ["contactUs"],
  footer: ["footer", "svg"],
  svg: ["svg"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  home: "div";
  navigationBar: typeof NavigationBar;
  hero: "div";
  foreground2: "div";
  services: "section";
  aboutUs: "section";
  contactUs: "section";
  footer: "section";
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomepage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomepage__VariantsArgs;
    args?: PlasmicHomepage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicHomepage__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicHomepage__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "home") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("home"),
  {
    // Helper components rendering sub-elements
    navigationBar: makeNodeComponent("navigationBar"),
    hero: makeNodeComponent("hero"),
    foreground2: makeNodeComponent("foreground2"),
    services: makeNodeComponent("services"),
    aboutUs: makeNodeComponent("aboutUs"),
    contactUs: makeNodeComponent("contactUs"),
    footer: makeNodeComponent("footer"),
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,

    // Page metadata
    pageMetadata: {
      title: "Pro Property Services",
      description:
        "Your all-in-one solution for maintaining, enhancing, and safeguarding your residential or commercial property. Offering services such as general contracting, painting, snow removal and more.",
      ogImageSrc: "",
      canonical: "https://www.propropertyservices.net"
    }
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
